export default __webpack_public_path__ + "static/media/balanza.eb16a4bd.svg";